
import { useContext, useState } from "react";
import "../style/exampleWebsite.css";
import ExampleDisplay from "./ExampleDisplay";
import ExampleNavbar from "../navbar/ExampleNavbar";
import { exampleData } from "../../../../../../dataSets/exampleData";
import { SubscriptionContext } from "../../../../../../contextApi/SubscriptionContext";

export default function ExampleWebsite() {
    const {theme} = useContext(SubscriptionContext);
    const [exampleDisplay, setExampleDisplay] = useState(0);
    
    return (
        <div className='exampleWebsite'>
            <ExampleNavbar setPage={setExampleDisplay} data={exampleData} theme={theme}/>
            <ExampleDisplay page={exampleDisplay} data={exampleData} theme={theme}/>
        </div>
    )
}
